import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomModal from './CustomModal';

function AccessModal({ show, setShow, modalType, onClose }) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const modalConfig = {
        access: {
            title: t('modal.access.title'),
            messageHtml: t('modal.access.messageHtml'),
            actionLabel: t('modal.access.actionBtn'),
            closeLabel: t('modal.access.closeBtn'),
        },
        limit: {
            title: t('modal.limit.title'),
            messageHtml: t('modal.limit.messageHtml'),
            actionLabel: t('modal.limit.actionBtn'),
            closeLabel: t('modal.limit.closeBtn'),
        },
        works: {
            title: t('modal.works.title'),
            messageHtml: t('modal.works.messageHtml'),
            actionLabel: t('modal.works.actionBtn'),
            closeLabel: t('modal.works.closeBtn'),
        },
        quota: {
            title: t('modal.quota.title'),
            messageHtml: t('modal.quota.messageHtml'),
            actionLabel: t('modal.quota.actionBtn'),
            closeLabel: t('modal.quota.closeBtn'),
        },
        image_upload: {
            title: t('modal.image_upload.title'),
            messageHtml: t('modal.image_upload.messageHtml'),
            closeLabel: t('modal.image_upload.closeBtn'),
        }
    };

    const handleClose = () => {
        setShow(false);
        onClose?.();
    };

    const handleAction = () => {
        handleClose();
        navigate('/pricing');
    };

    return (
        <CustomModal
            show={show}
            onClose={handleClose}
            title={modalConfig[modalType]?.title}
            messageHtml={modalConfig[modalType]?.messageHtml}
            closeLabel={modalConfig[modalType]?.closeLabel}
            actionLabel={modalConfig[modalType]?.actionLabel}
            actionClassName="bg-pink"
            onAction={modalConfig[modalType]?.actionLabel ? handleAction : null}
        />
    );
}

export default AccessModal;
